import PromoterCurate from './PromoterCurate';

export default PromoterCurate;
